import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SharedService } from "./shared.service";

@Injectable()
export class SpeakerService {
    public getSpeakerApi: string = "/svcs/session_catalog/app/es/speakerInstanceList";
    constructor(private http: HttpClient, public sharedService: SharedService) {}

    public getSpeakers(filter) {
        let params = {};
        if (filter.name) {
            params["name"] = filter.name;
        }
        params["limit"] = filter.limit;
        params["page"] = filter.page + 1;
        if (filter.ids != null && filter.ids.length > 0) {
            params["speakerIds"] = filter.ids;
        }
        return this.http.get(
            "/svcs/api/3.0/accounts/" +
                this.sharedService.account.code +
                "/events/" +
                this.sharedService.event.code +
                "/speakers",
            {
                params: params,
                observe: "response",
                headers: this.sharedService.headers
            }
        );
    }

    public getSpeaker(id) {
        return this.http.get("/svcs/conference_speakers/" + id, {
            observe: "response",
            headers: this.sharedService.headers
        });
    }

    public getSpeakersEs(filter?: any) {
        filter.eventId = this.sharedService.event.id;
        filter.eventCode = this.sharedService.event?.code;
        filter.eventUUID = this.sharedService.event?.uuid;
        filter.accountCode = this.sharedService.account?.code;
        filter.accountUUID = this.sharedService.account?.accountUUID;
        filter.speakerCatalogId = this.sharedService.setup.id;
        filter.catalogUUID = this.sharedService.setup.uuid;
        return this.http.post(this.getSpeakerApi, JSON.stringify(filter), {
            observe: "response",
            headers: this.sharedService.headers
        });
    }
}
